import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconList = ({ title, items }) => (
    <div className="container-fluid p-3">
      <h3 className="mb-4 fs-2">{title}</h3>
      <ul className="list-unstyled ps-4">
        {items.map((item, index) => (
          <li key={index} className="d-flex align-items-center mb-4 fs-5">
            <FontAwesomeIcon 
              icon={item.icon} 
              className="me-3" 
              style={{ minWidth: '1.25em' }}
              size="lg"
            />
            <span>{renderTextWithBold(item.text)}</span>
          </li>
        ))}
      </ul>
    </div>
  );

const renderTextWithBold = (text) => {
  if (typeof text === 'string') {
    return text;
  }
  
  return text.map((part, index) => {
    if (typeof part === 'string') {
      return part;
    }
    if (part.bold) {
      return <strong key={index}>{part.text}</strong>;
    }
    return part.text;
  });
};
  
export default IconList;